/* eslint-disable */
import React, { Component } from 'react';
import { connect } from "react-redux";
import Layout from '@components/shared/layout';
import AjaxLoader from '@components/shared/ajax_loader';
import AccordionGroup from '@components/accordion_group';
import AccordionChild from '@components/accordion_child';
import TableCobrancas from '@components/geracao-lote-cobranca/table_cobrancas';
import CustomSnackbar from '@components/shared/custom_snackbar'
import FormFiltro from '@components/geracao-lote-cobranca/form_filtro';
import { getPrestador, updatePrestador } from '@store/actions/index';
import m from '@utils/strings';
import '@styles/geracao-lote-cobranca.css';
import userManager from '@utils/userManager';

class GeracaoLoteCobranca extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activeKey: '1',
            snackbarType: 'error',
            snackbarMsg: '',
            showPrestadorLoader: false,
            isModalOpened: false,
        }

        setTimeout(() => {
            this.applyFilter(null);
        }, 600);
    }

    verifiyIfUserIsAuthenticated = () => {
        const { user } = this.props
        if (!user || user.expired) {
            userManager.signinRedirect();
        }
    }
    
    getUpdatePrestador = () => {
        const { user } = this.props
        if (user != null && user.profile != null) {
            if (!this.isFetchingPrestador) {
                this.isFetchingPrestador = true;
                let cpfCnpj = user.profile.prestador instanceof Array ? user.profile.prestador[0] : user.profile.prestador
                this.props.getPrestador(cpfCnpj, (result) => {
                    this.props.updatePrestador(result);
                    this.setState({ showPrestadorLoader: false });
                });
            }
        }
    }

    componentDidUpdate() {
        this.verifiyIfUserIsAuthenticated();
    }

    componentDidMount() {
        if(_.isEmpty(this.props.prestador)) {
            this.setState({ showPrestadorLoader: true });
            this.getUpdatePrestador(); 
        } 
        this.verifiyIfUserIsAuthenticated();
        document.addEventListener("keydown", this.handleKeyDown, false);
        this.focusFirstField();
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleKeyDown, false);
    }

    handleKeyDown = (event) => {
        if(event.key == 'F7' && this.state.activeKey == '1'){
            this.setState({ activeKey: '' });
        }
        else if (event.key == 'F7') {
            this.focusFirstField();
            this.setState({ activeKey: '1' });
        }
    }

    handleAccordionSelect = (activeKey) => {
        if(this.state.activeKey === '1'){
            this.setState({ activeKey: '' });
        }
        else {
            this.focusFirstField();
            this.setState({ activeKey: '1' });
        }
    }

    callSnackbar = (snackbarMsg, snackbarType) => {
        this.setState({ snackbarMsg });
        this.setState({ snackbarType });
        this.click();
    }

    changeModalOpenedStatus = () => {
        this.setState({ isModalOpened: !this.state.isModalOpened });
    }

    applyFilter = (params) => {
        this.resetGuiasSelecionadas();
        if(_.isEmpty(this.props.prestador)) {
            setTimeout(() => {
                this.applyFilter(null);
            }, 600);
            return ;
        }
        this.applyFilterTable(params)
    }

    render() {
        const { showPrestadorLoader } = this.state;
        const prestadorLoader = showPrestadorLoader? <AjaxLoader ajaxMessage={m.TELA_GERACAO_LOTE_COBRANCA.MENSAGEM_LOADER_BUSCANDO_PRESTADOR} /> : '';

        return (
            <div>
                {prestadorLoader}
                <Layout
                    user={this.props.user}
                    iconePath={''}
                    content={m.TELA_GERACAO_LOTE_COBRANCA.TITULO_PAGINA}
                />
                <div id='label-descricao'>
                    {m.TELA_GERACAO_LOTE_COBRANCA.TEXTO_ACIMA_ACCORDION}
                </div>
                <AccordionGroup 
                    withoutLateralMenu={true}
                    activeKey={this.state.activeKey}
                    onSelect={this.handleAccordionSelect}
                    childs={[
                        <AccordionChild 
                            componentToRender={
                                <FormFiltro 
                                    callSnackbar={this.callSnackbar}
                                    applyFilter={this.applyFilter}
                                    focusFirstField={e => this.focusFirstField = e}
                                    activeAccordion={this.state.activeKey}
                                    isModalOpened={this.state.isModalOpened}
                                />
                            }
                            title={m.TELA_GERACAO_LOTE_COBRANCA.TITULO_ACCORDION}
                            keyboardCommandKey="F7"
                            keyAccordion="1"
                            key="1"
                        />
                    ]}
                />
                <TableCobrancas 
                    updateTableRows={e => this.updateTableRows = e} 
                    updateApplyingFilter={e => this.updateApplyingFilter = e}
                    applyFilterTable={e => this.applyFilterTable = e}
                    callSnackbar={this.callSnackbar}
                    prestador={this.props.prestador}
                    resetGuiasSelecionadas={e => this.resetGuiasSelecionadas = e}
                    changeModalOpenedStatus={this.changeModalOpenedStatus}
                />
                <CustomSnackbar
                    setClick={click => this.click = click}
                    variant={this.state.snackbarType}
                    duration={2500}
                    content={this.state.snackbarMsg}
                />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        prestador: state.prestador,
    }
}

export default connect(mapStateToProps, { getPrestador, updatePrestador } )(GeracaoLoteCobranca);
